import React from 'react';
import HeroContent from '../HeroContent';
import Footer from '../Footer';
import Content from '../Content';

const App = () => (
  <React.Fragment>
    <HeroContent />
    <Content />
    <Footer />
  </React.Fragment>
);

export default App;



// WEBPACK FOOTER //
// ./src/universal/components/App/App.js